import { useParams, useNavigate } from "react-router-dom";
import { Star, ArrowLeft, BookOpen } from "lucide-react";
import { Sidebar } from "@/components/Sidebar";
import { Navigation } from "@/components/Navigation";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { MobileTabBar } from "@/components/MobileTabBar";
import { ShareMenu } from "@/components/ui/ShareMenu";
import { SocialMetaTags } from "@/components/SocialMetaTags";

const webtoonData = {
  "1": {
    id: 1,
    title: "T-Hunters",
    cover: "/lovable-uploads/coverthunter.webp",
    capa: "/lovable-uploads/b146e022-1fe8-40a4-861a-db11d4d1bc90.png",
    author: "Israel Guedes",
    genre: "Fantasy",
    description: "Para Ken'Ichi, já era difícil tentar ter uma vida normal seguindo os ensinamentos deixados por alguém importante para ele. E ainda tem que lidar com os problemas trazidos pela rixa entre duas organizações secretas: T-Hunters e Caçadores de Recompensas. Será muito azar? Ou tal situação o ajudará a resolver seus conflitos?",
    tags: ["Aventura", "Ação", "Drama"],
    rating: 4.8,
    views: 45678,
    releaseDate: "há cerca de 1 ano",
    episodes: [
      { id: 1, title: "Episode 1", thumbnail: "/lovable-uploads/581526663211.webp", date: "Apr 05, 2021", locked: false },
      { id: 2, title: "Episode 2", thumbnail: "/lovable-uploads/3101535418769.webp", date: "Apr 12, 2021", locked: false },
      { id: 3, title: "Episode 3", thumbnail: "/lovable-uploads/971526785490.webp", date: "Apr 19, 2021", locked: false },
      { id: 4, title: "Episode 4", thumbnail: "/lovable-uploads/951526762933.webp", date: "Apr 26, 2021", locked: true },
    ]
  },
  "2": {
    id: 2,
    title: "Solo Leveling",
    cover: "/lovable-uploads/0f4f44ac-af25-4eb7-aebe-ec2f2302f350.png",
    capa: "/lovable-uploads/e50af48f-7bd6-433c-b3ae-4737b720d1bb_z.png",
    author: "Dubu (Redice Studio)",
    genre: "Action",
    description: "Dez anos atrás, portais começaram a aparecer por todo o mundo, conectando-o a dungeons repletas de monstros. Alguns humanos receberam poderes e foram chamados de 'Caçadores', responsáveis por combater essas criaturas. Sung Jin-Woo é o mais fraco dos Caçadores Rank-E, conhecido como 'O Mais Fraco do Mundo'. Um dia, durante uma masmorra dupla extremamente perigosa, ele se encontra em uma situação de vida ou morte e recebe um estranho poder...",
    tags: ["Action", "Adventure", "Fantasy", "Supernatural", "Martial Arts"],
    rating: 4.9,
    views: 45678,
    releaseDate: "há cerca de 1 ano",
    episodes: [
      { id: 1, title: "Episode 1", thumbnail: "/lovable-uploads/2804a12c-0da4-4a04-a446-800177214eb0.png", date: "Apr 05, 2021", locked: false },
      { id: 2, title: "Episode 2", thumbnail: "/lovable-uploads/63846342-f428-4efe-9077-1ec6017efdf9.png", date: "Apr 12, 2021", locked: false },
      { id: 3, title: "Episode 3", thumbnail: "/lovable-uploads/d0461451-fd2c-4fbd-b822-7b3e72ae0d1a.png", date: "Apr 19, 2021", locked: false },
      { id: 4, title: "Episode 4", thumbnail: "/lovable-uploads/0f4f44ac-af25-4eb7-aebe-ec2f2302f350.png", date: "Apr 26, 2021", locked: true },
      { id: 5, title: "Episode 5", thumbnail: "/lovable-uploads/4ef64414-f30b-4d5b-babd-31699f267428.png", date: "May 03, 2021", locked: true },
    ]
  },
  "3": {
    id: 3,
    title: "Tower of God",
    cover: "/lovable-uploads/c577f9da-620e-45e7-8bb9-1c7314b7862e.png",
    capa: "/lovable-uploads/c577f9da-620e-45e7-8bb9-1c7314b7862e.png",
    author: "SIU",
    genre: "Fantasy",
    description: "What do you desire? Money and wealth? Honor and pride? Authority and power? Revenge? Or something that transcends them all? Whatever you desire—it's here.",
    tags: ["Fantasy", "Adventure", "Action", "Mystery", "Drama"],
    rating: 4.7,
    views: 32450,
    releaseDate: "há cerca de 2 anos",
    episodes: []
  },
  "4": {
    id: 4,
    title: "Omniscient Reader",
    cover: "/lovable-uploads/fcd141f3-253f-40e3-ba9a-70b47b49d47f.png",
    capa: "/lovable-uploads/fcd141f3-253f-40e3-ba9a-70b47b49d47f.png",
    author: "sing N song",
    genre: "Action",
    description: "Only I know the end of this world. One day, our MC finds himself stuck in the world of his favorite webnovel. What does he do to survive? It is a world struck by catastrophe and danger all around. His edge? He knows the plot of the story to end. Because he was the sole reader that stuck with it. Read his story to see how he survives!",
    tags: ["Action", "Adventure", "Fantasy", "Apocalyptic", "Supernatural"],
    rating: 4.8,
    views: 28956,
    releaseDate: "há cerca de 1 ano",
    episodes: []
  },
};

const WebtoonDetails = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const webtoon = webtoonData[id as keyof typeof webtoonData];
  
  if (!webtoon) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navigation />
        <div className="flex flex-1">
          <Sidebar />
          <main className="flex-1 p-4 pt-24">
            <div className="flex justify-start mb-4">
              <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
                <ArrowLeft className="h-5 w-5" />
              </Button>
            </div>
            <div className="flex items-center justify-center h-full">
              <h1 className="text-2xl">Webtoon não encontrado</h1>
            </div>
          </main>
        </div>
        <MobileTabBar />
      </div>
    );
  }

  const handleReadNow = () => {
    navigate(`/webtoon/${id}/episode/1`);
  };

  return (
    <div className="flex flex-col min-h-screen">
      {webtoon && (
        <SocialMetaTags
          title={webtoon.title || "InkWebtoons"}
          description={webtoon.description || "Confira esta incrível webtoon no InkWebtoons"}
          imageUrl={webtoon.cover}
          url={window.location.href}
          contentType="webtoon"
          contentId={id || ""}
        />
      )}
      
      <Navigation />
      <div className="flex flex-1">
        <Sidebar />
        <main className="flex-1 relative">
          <div 
            className="absolute top-0 left-0 right-0 h-[60vh] bg-cover bg-center"
            style={{ 
              backgroundImage: `url(${webtoon.cover})`,
              filter: 'blur(2px)'
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background"></div>
          </div>

          <div className="relative pt-16 pb-6 min-h-screen mx-auto max-w-5xl px-4 md:px-6 lg:px-8">
            <div className="z-10 mb-4 mt-4">
              <Button 
                variant="ghost" 
                size="icon" 
                onClick={() => navigate(-1)}
                className="bg-background/20 backdrop-blur-sm text-white rounded-full hover:bg-background/30"
              >
                <ArrowLeft className="h-5 w-5" />
              </Button>
            </div>

            <div className="flex flex-col md:flex-row gap-8 mt-8 z-10">
              <div className="flex-shrink-0 z-10">
                <div className="w-48 h-64 md:w-64 md:h-96 rounded-lg overflow-hidden shadow-xl mx-auto md:mx-0">
                  <img 
                    src={webtoon.capa} 
                    alt={webtoon.title} 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="flex flex-col text-white z-10 max-w-2xl mx-auto md:mx-0">
                <h1 className="text-3xl md:text-4xl font-bold mb-2 text-center md:text-left">{webtoon.title}</h1>
                
                <div className="flex items-center mb-2 justify-center md:justify-start">
                  <div className="flex items-center">
                    <img 
                      src="/lovable-uploads/725d4a82-6ca0-4e39-8b72-3e42aff89638.png"
                      alt="Author Avatar" 
                      className="w-8 h-8 rounded-full mr-2" 
                    />
                    <span className="text-sm md:text-base">{webtoon.author}</span>
                  </div>
                  <span className="mx-2 text-gray-400">•</span>
                  <span className="text-sm md:text-base text-gray-300">{webtoon.releaseDate}</span>
                </div>
                
                <div className="flex items-center gap-4 mb-6 justify-center md:justify-start">
                  <div className="flex items-center">
                    <Star className="h-5 w-5 text-yellow-400 mr-1 fill-yellow-400" />
                    <span>{webtoon.rating}</span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-gray-300">{webtoon.views.toLocaleString()} visualizações</span>
                  </div>
                </div>
                
                <div className="flex flex-wrap gap-2 mb-6 justify-center md:justify-start">
                  {webtoon.tags.map((tag, index) => (
                    <Badge key={index} variant="secondary" className="hover:bg-primary/20 cursor-pointer">
                      {tag}
                    </Badge>
                  ))}
                </div>
                
                <p className="text-gray-300 mb-8 line-clamp-6 md:line-clamp-none text-center md:text-left">
                  {webtoon.description}
                </p>
                
                <div className="flex gap-4 mt-auto justify-center md:justify-start">
                  <Button 
                    className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-8"
                    onClick={handleReadNow}
                  >
                    <BookOpen className="mr-2 h-5 w-5" />
                    Ler Agora
                  </Button>
                  <Button variant="outline" className="text-white border-white/20 rounded-full hover:bg-white/10">
                    Seguir
                  </Button>
                  <ShareMenu
                    title={webtoon.title || ""}
                    url={window.location.href}
                    imageUrl={webtoon.cover}
                  />
                </div>
              </div>
            </div>

            <div className="mt-24 pt-8 z-10 relative">
              <h2 className="text-2xl font-bold mb-6">Episódios</h2>
              
              <div className="grid grid-cols-1 gap-4">
                {webtoon.episodes && webtoon.episodes.length > 0 ? (
                  webtoon.episodes.map((episode) => (
                    <div 
                      key={episode.id} 
                      className="flex items-center p-4 rounded-lg border border-border bg-card/30 backdrop-blur-sm hover:bg-card/50 transition-colors cursor-pointer"
                      onClick={() => !episode.locked && navigate(`/webtoon/${id}/episode/${episode.id}`)}
                    >
                      <div className="h-16 w-24 mr-4 rounded overflow-hidden flex-shrink-0">
                        <img 
                          src={episode.thumbnail} 
                          alt={episode.title} 
                          className="h-full w-full object-cover"
                        />
                      </div>
                      <div className="flex flex-col flex-grow">
                        <h3 className="font-medium">{episode.title}</h3>
                        <span className="text-sm text-muted-foreground">{episode.date}</span>
                      </div>
                      {episode.locked && (
                        <div className="bg-background/50 px-3 py-1 rounded-full flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1">
                            <rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                          </svg>
                          <span className="text-xs">Bloqueado</span>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="p-4 rounded-lg border border-border bg-card/30 backdrop-blur-sm">
                    <p className="text-muted-foreground">Nenhum episódio disponível no momento.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
      <MobileTabBar />
    </div>
  );
};

export default WebtoonDetails;
